import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {HandleErrorService} from './handle-error.service';
import Swal from 'sweetalert2';
import {ApiService} from '../core/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class SeoService {

  constructor(private serviceApi: ApiService, private handleError: HandleErrorService) {
  }

  editMetaData(body): Observable<any> {
    return this.serviceApi.put(`Seo/USeo`, body)
      .pipe(
        catchError(this.handleError.catchHttpError),
        tap((data: { valid: boolean, message: string }) => {
          if (data.valid) {
            Swal.fire({
              icon: 'success',
              confirmButtonText: 'Aceptar',
              text: data.message
            });
          }
        })
      );
  }

  createMetaData(): Observable<any> {
    return this.serviceApi.post(`Seo/Seo`, {})
      .pipe(
        catchError(this.handleError.catchHttpError),
        tap((data: { valid: boolean, message: string }) => {
          if (data.valid) {
            Swal.fire({
              icon: 'success',
              confirmButtonText: 'Aceptar',
              text: data.message
            });
          }
        })
      );
  }

  deleteMetaData(id): Observable<any> {
    return this.serviceApi.delete(`Seo/ByIdSeo/${id}`)
      .pipe(
        catchError(this.handleError.catchHttpError),
        tap((data: { valid: boolean, message: string }) => {
          if (data.valid) {
            Swal.fire({
              icon: 'success',
              confirmButtonText: 'Aceptar',
              text: data.message,
            });
          }
        })
      );
  }

  getMetaData(id): Observable<any> {
    return this.serviceApi.get(`Configuration/ConfigurationSeo/${id}`)
      .pipe(catchError(this.handleError.catchHttpError));
  }

  changeMetaDataStatus(): Observable<any> {
    return this.serviceApi.patch(`Seo/SeoStatus`, {})
      .pipe(
        catchError(this.handleError.catchHttpError),
        tap((data: { valid: boolean, message: string }) => {
          if (data.valid) {
            Swal.fire({
              icon: 'success',
              confirmButtonText: 'Aceptar',
              text: data.message,
            });
          }
        })
      );
  }

}

